.toggle {
	display: inline-flex;
	align-items: center;
	min-height: var(--control-h);
	background: var(--surface-input);
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	padding: 2px;
	gap: 2px;
}

.option {
	border: none;
	background: transparent;
	padding: 6px 14px;
	font-size: 0.875rem;
	font-weight: 500;
	border-radius: calc(var(--radius-md) - 4px);
	color: var(--ink-muted);
	text-decoration: none;
	cursor: pointer;
	transition:
		background-color 120ms ease,
		color 120ms ease;
}

.option[aria-pressed='true'] {
	background: var(--surface-card);
	color: var(--ink);
	box-shadow: 0 1px 2px rgb(0 0 0 / 0.06);
}

.option:hover:not([aria-pressed='true']) {
	color: var(--ink);
	text-decoration: none;
}
